export default __webpack_public_path__ + "static/media/003-arctic fox.bd51f9fd.svg";